
import { authorize } from "../helper/authorize-token";
import superagent from 'superagent';
import {deep_copy} from "../../lib/js-utils";

const INBOX_CLEAR = "INBOX_CLEAR";
const INBOX_GET_UNREAD_COUNT = "INBOX_GET_UNREAD_COUNT";
const INBOX_SET_UNREAD_COUNT = "INBOX_SET_UNREAD_COUNT";
const INBOX_LOAD_INBOX = "INBOX_LOAD_INBOX";
const INBOX_SET_LOADING = "INBOX_SET_LOADING";
const INBOX_MARK_MESSAGE_READ = "INBOX_MARK_MESSAGE_READ";
const INBOX_SEND_MESSAGE = "INBOX_SEND_MESSAGE";
const INBOX_SET_SENDING = "INBOX_SET_SENDING";

const ZERO_STATE = {
  messages: [],
  unread_count: 0,
  loading: false,
  sending: false,
};

const emailClear = () => {
  return dispatch => {
    dispatch({
      type: INBOX_CLEAR,
    })
  }
};

const markMessageRead = message_id => {
  return (dispatch, getState) => {
    const msg = getState().inbox.messages.find(
      msg => msg.id === message_id);
    if (!msg || msg.read) {
      return;
    }

    dispatch({
      type: INBOX_MARK_MESSAGE_READ,
      payload: superagent
        .post("/api/inbox/mark-message-read")
        .send({ message_id })
        .use(authorize(getState().user.token)),
    })
  }
};

const processMarkMessageReadResults = (state, payload) => {
  const result = payload.body.data;
  if (!result.did_update) {
    return state;
  }
  const new_state = deep_copy(state);
  const msg = new_state.messages.find(msg => msg.id === result.message_id);
  if (msg) {
    msg.read = true;
  }
  new_state.unread_count = result.unread_count;
  return new_state;
}

const sendMessage = (from, to, subject, text) => {
  return (dispatch, getState) => {
    dispatch({
      type: INBOX_SET_SENDING,
      sending: true,
    })
    dispatch({
      type: INBOX_SEND_MESSAGE,
      payload: superagent
        .post("/api/inbox/send-message")
        .use(authorize(getState().user.token))
        .send({from, to, subject, text})
    })
  }
};

const processSentMessage = (state, new_msg) => {
  const new_state = deep_copy(state);
  new_state.messages.unshift(new_msg);
  new_state.sending = false;
  return new_state;
}

const emailLoadInbox = next_token => {
  return (dispatch, getState) => {
    dispatch({
      type: INBOX_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: INBOX_LOAD_INBOX,
      payload: superagent
        .post("/api/inbox/get-inbox")
        .send({ next_token })
        .use(authorize(getState().user.token))
    });
  }
}

const getUnreadCount = () => {
  return (dispatch, getState) => {
    dispatch({
      type: INBOX_GET_UNREAD_COUNT,
      payload: superagent
        .post("/api/inbox/get-unread")
        .use(authorize(getState().user.token))
    });
  };
}

const inboxReducer = (state = ZERO_STATE, action) => {

  switch(action.type) {
    case INBOX_CLEAR:
      return ZERO_STATE;
    case INBOX_GET_UNREAD_COUNT + "_FULFILLED":
      const unread_count = action.payload.body.data.unread_count;
      return {
        ...state,
        unread_count,
      }
    case INBOX_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      }
    case INBOX_SET_SENDING:
      return {
        ...state,
        sending: action.sending,
      }
    case INBOX_LOAD_INBOX + "_FULFILLED":
      const messages = action.payload.body.data;
      return {
        ...state,
        messages: messages.items,
        next_token: messages.next_token,
        loading: false,
      }
    case INBOX_SEND_MESSAGE + "_FULFILLED":
      return processSentMessage(state, action.payload.body.data.sent_msg);
    case INBOX_MARK_MESSAGE_READ + "_FULFILLED":
      return processMarkMessageReadResults(state, action.payload);
    case INBOX_SET_UNREAD_COUNT:
      return {
        ...state,
        unread_count: action.unread_count,
      }
    default:
      return state;
  }
}

export { inboxReducer, emailClear, sendMessage, getUnreadCount,
  INBOX_SET_UNREAD_COUNT, emailLoadInbox, markMessageRead };
